import script from "./GridAudioAnalyzer.vue?vue&type=script&setup=true&lang=js"
export * from "./GridAudioAnalyzer.vue?vue&type=script&setup=true&lang=js"

import "./GridAudioAnalyzer.vue?vue&type=style&index=0&id=12a37c5b&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12a37c5b"]])

export default __exports__